import { gql } from '@apollo/client';

export const DOCUMENT_HISTORY_QUERY = gql`
  query documentHistory($fileId: String) {
    documentHistory(fileId: $fileId)
  }
`;

export const ATTACHMENT_AND_PRINT_GENERATED_STATUS_QUERY = gql`
  query getAttachmentsAndPrintsGeneratedStatus($documentId: Int!, $siteId: Int!) {
    getAttachmentsAndPrintsGeneratedStatus(documentId: $documentId, siteId: $siteId) {
      attachmentsAndPrintsGeneratedStatus
    }
  }
`;

export const DOCUMENT_PARTNERS_QUERY = gql`
  query documentPartners($documentId: Int!, $siteId: Int!) {
    documentPartners(documentId: $documentId, siteId: $siteId) {
      partnerId
      partnerName
      isDocumentPartner
    }
  }
`;

export const DOCUMENT_ASSETS_QUERY = gql`
  query documentAssets($documentId: Int!, $siteId: Int!) {
    documentAssets(documentId: $documentId, siteId: $siteId) {
      documentDetailId
      internalId
      assetFullName
    }
  }
`;

export const AVAILABLE_DOCUMENT_TRANSITIONS_QUERY = gql`
  query availableDocumentTransitions {
    availableDocumentTransitions {
      initialStateId
      initialStateCode
      initialStateName
      finalStateId
      finalStateCode
      finalStateName
    }
  }
`;

export const GET_FILE_FOR_PREVIEW_QUERY = gql`
  query getFileForPreview($fileId: String!) {
    getFileForPreview(fileId: $fileId) {
      content
      name
      contentType
    }
  }
`;

export const VALIDATE_STATE_CHANGE_QUERY = gql`
  query validateStateChange($documentId: Int!, $siteId: Int!, $oldStateId: Int!, $newStateId: Int!) {
    validateStateChange(documentId: $documentId, siteId: $siteId, oldStateId: $oldStateId, newStateId: $newStateId) {
      isValidationSuccessful
      errorMessage
    }
  }
`;

export const DOC_ATTACHMENT_STATE_TRANSITIONS_QUERY = gql`
  query getDocAttachmentStateTransitions($documentAttachmentId: Int!) {
    getDocAttachmentStateTransitions(documentAttachmentId: $documentAttachmentId) {
      transitionId
      documentAttachmentId
      stateId
      stateName
      userId
      userName
      transitionMoment
      transitionEnd
    }
  }
`;

export const BUFFER_TEMP_FILES_QUERY = gql`
  query bufferTempFiles($documentId: Int!, $siteId: Int!) {
    bufferTempFiles(documentId: $documentId, siteId: $siteId) {
      content
      name
      contentType
    }
  }
`;

export const BUFFER_TEMP_FILES_VALIDITY = gql`
  query bufferTempFilesValidity {
    bufferTempFilesValidity
  }
`;
